module.exports = __webpack_public_path__ + "static/img/personal-service-1.4572d5b1.png";